import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HeadingComponent from "../_common/headingComponent";

const WelcomeComponent = (props) => {
  const { t } = useTranslation();
  return (
    <div>
      <HeadingComponent text={t("common.regSuccess.title")} />
      <div className="mx-3 text-justify terms">
        <p>
          {t("user.welcome.body")}
        </p>
      </div>
      <div className="fixed-bottom stripe py-3 border-top fixed-bottom-own">
        <div className="col-md-12 text-center">
          <Link to={`/${props.roleType}/video`}>
            <button className="btnFooter">{t("common.continue")}</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WelcomeComponent;
